export default {
  columns: {
    title: 'Título',
    image: 'Imagem',
    button_url: 'URL do Botão',
    button_text: 'Texto do Botão',
    description: 'Descrição',
    visible: 'Visível',
    actions: 'Ações',
  },
  buttons: {
    create_post: 'Criar Publicação',
    edit: 'Editar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },
  title: 'Publicações em destaque',
  delete_confirmation: 'Tem a certeza que pretende eliminar esta publicação?',
};
